import api from './api';

const ENDPOINT = 'training-responses';

const TrainingResponsesService = {
  get: (params = null) => api.get(ENDPOINT, { params }),
  export: (filters) => api.post(`${ENDPOINT}/export`, { filters }),
};

export default TrainingResponsesService;
